






















import { Component, Vue, Prop } from "vue-property-decorator";
import BiPopularCard from "./BiPopularCard";
import { PopularCardData, BiCardType } from "@/types";

@Component({
  name: "BiTopCards",

  components: {
    BiPopularCard,
  },
})
export default class Funnel extends Vue {
  @Prop({ type: Array, required: true }) items!: Array<PopularCardData>;
  @Prop({ type: String, required: true }) label!: String;
  @Prop({ type: String, required: true }) type!: BiCardType;

  isShownAllCards = false;
  maximumCard: number = 3;

  expandCards() {
    if(this.type === 'case'){
    this.$gtag.event('BI_expert_cases')
    } else {
    this.$gtag.event('BI_expert_events')
    }

    this.isShownAllCards = true;
    this.maximumCard = this.items.length;
  }
}
